import Enumerator from '../global/Enumerator';

export const contactResidencyStatusOptions = [
  'none',
  'citizen',
  'permanent_resident',
  'non_resident',
  'work_permit'
];

export class ContactResidencyStatusOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'citizen';
        break;
      case '2':
        correctOption = 'permanent_resident';
        break;
      case '3':
        correctOption = 'non_resident';
        break;
      case '4':
        correctOption = 'work_permit';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactResidencyStatusOption.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  citizen: {
    get title() {
      return 'Citizen';
    }
  },
  permanent_resident: {
    get title() {
      return 'Permanent resident';
    }
  },
  non_resident: {
    get title() {
      return 'Non-resident';
    }
  },
  work_permit: {
    get title() {
      return 'Work permit';
    }
  }
});

export default {
  contactResidencyStatusOptions,
  ContactResidencyStatusOption
};
